// Libs
import { ReactElement, useContext, MouseEvent } from 'react';
import clsx from 'clsx';
// App
import styles from './left-panel.module.scss';
import Copyrights from './copyrights';
import NavMenu from './nav-menu';
import { Icon, IconButton, Stack, Tooltip } from 'ui-components';
import { LeftPanelProps } from './left-panel-props.interface';
import Link from 'next/link';
import { SHOP_ADMIN_PAGES_URLS } from '@/fragments/shop-administration/shop-administration.constants';
import { LeftPanelContext } from './left-panel-context';
import { useAccount } from '@/fragments/_shared/account';

const LeftPanel = (props: LeftPanelProps): ReactElement => {
  const { children, className, shouldShowMenu = true, ...rest } = props;
  const { isOpen: isCollapsed, setOpen } = useContext(LeftPanelContext);
  const { account } = useAccount();
  const shopId = account?.shopId;

  const getHomeUrl = () => {
    if (!shopId) return '/';

    return `${SHOP_ADMIN_PAGES_URLS['shop-details']}?shp_id=${shopId}`;
  };

  const toggleLeftPanelCollapsed = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();

    setOpen(!isCollapsed);
  };

  return (
    <div className={clsx(styles.root, isCollapsed && styles.collapsed, className)} {...rest}>
      <Stack position="absolute" right={(isCollapsed && 15) || 5} bottom={35} zIndex={1000}>
        <IconButton onClick={toggleLeftPanelCollapsed}>
          {!isCollapsed && (
            <Tooltip title="Réduire" enterDelay={1000} placement="right">
              <div>
                <Icon name="left-arrow" />
              </div>
            </Tooltip>
          )}
          {isCollapsed && (
            <Tooltip title="Ouvrir" enterDelay={1000} placement="right">
              <div>
                <Icon name="right-arrow" />
              </div>
            </Tooltip>
          )}
        </IconButton>
      </Stack>
      <Stack mt={4} px={!isCollapsed && 4} alignItems={isCollapsed && 'center'}>
        <Link href={getHomeUrl()} className={styles.link}>
          {!isCollapsed && (
            <div className={styles.logoText}>
              <Icon name="brand" />
            </div>
          )}
          {isCollapsed && (
            <div className={styles.logo}>
              <Icon name="brand-logo" />
            </div>
          )}
        </Link>
      </Stack>
      {shouldShowMenu && (
        <Stack justifyContent="center" px={(!isCollapsed && 2) || 0.5} mt={3} mb={4}>
          <NavMenu className={styles.navMenu} isCollapsed={isCollapsed} />
        </Stack>
      )}
      {children}
      {!isCollapsed && (
        <Stack direction="column" mt="auto" mb={4} px={2} justifyContent="center" alignItems="center">
          <Link href={getHomeUrl()} className={styles.link}>
            <div className={styles.logo}>
              <Icon name="brand-logo" />
            </div>
          </Link>
          <Stack mt={1}>
            <Copyrights label="" />
          </Stack>
        </Stack>
      )}
    </div>
  );
};

export default LeftPanel;
